import { render, staticRenderFns } from "./BuiltInListItems.vue?vue&type=template&id=54fbc715&"
import script from "./BuiltInListItems.vue?vue&type=script&lang=ts&"
export * from "./BuiltInListItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports